import React, { useEffect, useState } from 'react';
import api, { apiError } from '../api';

export default function PasswordChangeModal({ isOpen, onClose }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      setMessage('');
      setError('');
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const submit = async (event) => {
    event.preventDefault();
    setError('');
    setMessage('');
    if (newPassword.length < 6) {
      setError('New password must be at least 6 characters long.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('New passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      await api.post('/change-password', { current_password: currentPassword, new_password: newPassword });
      setMessage('Password updated successfully! You can close this window.');
    } catch (requestError) {
      setError(apiError(requestError, 'Failed to update password.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" role="presentation" onMouseDown={onClose}>
      <section className="modal-content" role="dialog" aria-modal="true" aria-labelledby="password-title" onMouseDown={(event) => event.stopPropagation()}>
        <button type="button" className="modal-close-button" aria-label="Close password change" onClick={onClose}>×</button>
        <h2 id="password-title">Change Your Password</h2>
        {error && <div className="alert alert-error" role="alert">{error}</div>}
        {message && <div className="alert alert-success" role="status">{message}</div>}
        <form onSubmit={submit}>
          <label className="input-group" htmlFor="current-password">Current Password<input id="current-password" className="form-control" type="password" value={currentPassword} onChange={(event) => setCurrentPassword(event.target.value)} required disabled={Boolean(message)} /></label>
          <label className="input-group" htmlFor="new-password">New Password<input id="new-password" className="form-control" type="password" value={newPassword} onChange={(event) => setNewPassword(event.target.value)} required disabled={Boolean(message)} /></label>
          <label className="input-group" htmlFor="confirm-password">Confirm New Password<input id="confirm-password" className="form-control" type="password" value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} required disabled={Boolean(message)} /></label>
          <div className="modal-actions">
            {!message && <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? 'Updating...' : 'Update Password'}</button>}
            <button type="button" className="btn btn-secondary" onClick={onClose}>Close</button>
          </div>
        </form>
      </section>
    </div>
  );
}
